import { useState } from "react";
import { useHistory } from 'react-router-dom';
import svgPaths from "./svg-vm2yd368c4";
import "./figma.css";
import SlideToStart from "./SlideToStart";
import AuthForm from "./AuthForm";
import { useAuth } from "../../context/AuthContext";

function Group2085662883() {
  return (
    <div className="relative size-full">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 218 259">
        <g id="Group 2085662883">
          <path d={svgPaths.p34cc3280} fill="var(--fill-0, #FFB518)" id="path13" />
          <path d={svgPaths.p8a16c00} fill="var(--fill-0, #DD4506)" id="path14" />
        </g>
      </svg>
    </div>
  );
}

function Group2085662882() {
  return (
    <div className="absolute inset-[0.1%_-1.41%_77.49%_54.63%]">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 184 191">
        <g id="Group 2085662882">
          <path d={svgPaths.pa4dd200} fill="var(--fill-0, #F9672B)" id="path8" />
          <path d={svgPaths.p210f0c80} fill="var(--fill-0, #914650)" id="path9" />
        </g>
      </svg>
    </div>
  );
}

function Frame2147239049() {
  return (
    <div className="absolute h-[5px] left-[17px] top-[559.77px] w-[73px]">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 73 5">
        <g id="Frame 2147239049">
          <line id="Line 367" stroke="var(--stroke-0, #DD4506)" strokeLinecap="round" strokeWidth="5" x1="2.5" x2="25.5" y1="2.5" y2="2.5" />
          <line id="Line 368" stroke="var(--stroke-0, #C0C0C0)" strokeLinecap="round" strokeWidth="5" x1="34.5" x2="39.5" y1="2.5" y2="2.5" />
          <line id="Line 369" stroke="var(--stroke-0, #C0C0C0)" strokeLinecap="round" strokeWidth="5" x1="48.5" x2="53.5" y1="2.5" y2="2.5" />
          <line id="Line 370" stroke="var(--stroke-0, #C0C0C0)" strokeLinecap="round" strokeWidth="5" x1="62.5" x2="67.5" y1="2.5" y2="2.5" />
        </g>
      </svg>
    </div>
  );
}

function Frame2147239051() {
  return (
    <div className="h-[140px] relative w-[150px]">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 150 140">
        <g id="Frame 2147239051">
          <path d={svgPaths.p30a5c780} fill="var(--fill-0, #1BF968)" id="path15" />
          <path d={svgPaths.pdb0dd00} fill="var(--fill-0, #221F1F)" id="path16" />
        </g>
      </svg>
    </div>
  );
}

function Logo1() {
  return (
    <div className="absolute h-[223px] left-[82px] top-[225px] w-[239px]" data-name="logo 1">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 239 223">
        <g clipPath="url(#clip0_1_97)" id="logo 1">
          <path d={svgPaths.p13215b00} fill="var(--fill-0, #C84248)" id="Vector" />
          <path d={svgPaths.pfe9a670} fill="var(--fill-0, #1D1D1B)" id="Vector_2" />
          <path d={svgPaths.p30995e00} fill="var(--fill-0, #C84248)" id="Vector_3" />
          <path d={svgPaths.p31887c70} fill="var(--fill-0, #C84248)" id="Vector_4" />
          <path d={svgPaths.p3c03a980} fill="var(--fill-0, #C84248)" id="Vector_5" />
          <path d={svgPaths.p22f0af00} fill="var(--fill-0, #C84248)" id="Vector_6" />
          <path d={svgPaths.p1e4300} fill="var(--fill-0, #C84248)" id="Vector_7" />
          <path d={svgPaths.p18b1a700} fill="var(--fill-0, #C84248)" id="Vector_8" />
          <path d={svgPaths.p1d7426f0} fill="var(--fill-0, #C84248)" id="Vector_9" />
          <path d={svgPaths.p3a52fc00} fill="var(--fill-0, #C84248)" id="Vector_10" />
          <path d={svgPaths.p2f932c80} fill="var(--fill-0, #C84248)" id="Vector_11" />
          <path d={svgPaths.p1fc47fc0} fill="var(--fill-0, #C84248)" id="Vector_12" />
          <path d={svgPaths.p2471a00} fill="var(--fill-0, #C84248)" id="Vector_13" />
          <path d={svgPaths.p23150500} fill="var(--fill-0, #C84248)" id="Vector_14" />
          <path d={svgPaths.p356af980} fill="var(--fill-0, black)" id="Vector_15" />
          <path d={svgPaths.p15a6d500} fill="var(--fill-0, black)" id="Vector_16" />
          <path d={svgPaths.p1906c700} fill="var(--fill-0, black)" id="Vector_17" />
          <path d={svgPaths.p205b3400} fill="var(--fill-0, black)" id="Vector_18" />
          <path d={svgPaths.p271be800} fill="var(--fill-0, black)" id="Vector_19" />
          <path d={svgPaths.p15119200} fill="var(--fill-0, black)" id="Vector_20" />
          <path d={svgPaths.p2cee0e00} fill="var(--fill-0, black)" id="Vector_21" />
          <path d={svgPaths.p13078f00} fill="var(--fill-0, black)" id="Vector_22" />
          <path d={svgPaths.p3b5dd700} fill="var(--fill-0, #C84248)" id="Vector_23" />
          <path d={svgPaths.p31b94700} fill="var(--fill-0, #C84248)" id="Vector_24" />
          <path d={svgPaths.p2f07290} fill="var(--fill-0, #C84248)" id="Vector_25" />
          <path d={svgPaths.p372e5220} fill="var(--fill-0, #C84248)" id="Vector_26" />
          <path d={svgPaths.p8636740} fill="var(--fill-0, #C84248)" id="Vector_27" />
          <path d={svgPaths.p32795200} fill="var(--fill-0, #C84248)" id="Vector_28" />
          <path d={svgPaths.p27896000} fill="var(--fill-0, black)" id="Vector_29" />
          <g id="Group">
            <path d={svgPaths.p27ff4e80} fill="var(--fill-0, #1D1D1B)" id="Vector_30" />
            <path d={svgPaths.p710cd00} fill="var(--fill-0, #1D1D1B)" id="Vector_31" />
            <path d={svgPaths.p16699480} fill="var(--fill-0, #1D1D1B)" id="Vector_32" />
            <path d={svgPaths.p31259b00} fill="var(--fill-0, #1D1D1B)" id="Vector_33" />
            <path d={svgPaths.pa1a1b80} fill="var(--fill-0, #1D1D1B)" id="Vector_34" />
            <path d={svgPaths.p176d5400} fill="var(--fill-0, #1D1D1B)" id="Vector_35" />
            <path d={svgPaths.p33352638} fill="var(--fill-0, #1D1D1B)" id="Vector_36" />
            <path d={svgPaths.p3362c9f0} fill="var(--fill-0, #1D1D1B)" id="Vector_37" />
            <path d={svgPaths.p1d5a1980} fill="var(--fill-0, #1D1D1B)" id="Vector_38" />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1_97">
            <rect fill="white" height="223" width="239" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export default function Accueil() {
  const [showForm, setShowForm] = useState(false);
  const history = useHistory();
  const { session, setSession } = useAuth();

  const handleSlideCompleted = () => {
    if (session) {
      history.replace('/app/dashboard');
      return;
    }
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };

  const handleAuthSuccess = (payload: Parameters<typeof setSession>[0]) => {
    setSession(payload);
    setShowForm(false);
    history.replace('/app/dashboard');
  };

  return (
    <div className="figma-import bg-white relative size-full" data-name="Accueil">
      <div className="absolute flex inset-[-0.75%_47.97%_68.8%_-7.38%] items-center justify-center">
        <div className="flex-none h-[258.66px] w-[217.143px]" style={{ transform: "rotate(176.276deg) scaleY(-1)" }}>
          <Group2085662883 />
        </div>
      </div>
      <Group2085662882 />
      <div className="absolute inset-[70.04%_9.67%_28.31%_87.02%]" data-name="Vector">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 13 14">
          <path d={svgPaths.p1f91a7b0} fill="var(--fill-0, #FFB518)" id="Vector" />
        </svg>
      </div>
      <div className="absolute inset-[62.3%_10.69%_33.83%_80.66%]" data-name="Vector">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 34 33">
          <path d={svgPaths.p3e111f2} fill="var(--fill-0, #F9672B)" id="Vector" />
        </svg>
      </div>
      <div className="absolute h-[19px] left-[341px] top-[384.77px] w-[62px]">
        <div className="absolute inset-[-31.64%_-9.68%_-31.58%_-9.68%]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 74 32">
            <path d={svgPaths.p1fc26100} id="Vector 85" stroke="var(--stroke-0, #1BF968)" strokeLinecap="round" strokeWidth="12" />
          </svg>
        </div>
      </div>
      <div className="absolute h-[15px] left-[-9px] top-[440.77px] w-[62px]">
        <div className="absolute inset-[-40%_-9.68%_-40.02%_-9.68%]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 74 27">
            <path d={svgPaths.p10822d80} id="Vector 86" stroke="var(--stroke-0, #FFB518)" strokeLinecap="round" strokeWidth="12" />
          </svg>
        </div>
      </div>
      <Frame2147239049 />
      <div className="absolute flex flex-col font-['Fredoka:SemiBold',_sans-serif] font-semibold h-[112px] justify-center leading-[0] left-[17px] text-[36px] text-black top-[629px] translate-y-[-50%] w-[376px]" style={{ fontVariationSettings: "'wdth' 100" }}>
        <p className="leading-none">
          {`Défi formation Unkonito Expert : `}
          <br aria-hidden="true" />
          Es-tu prêt ?
        </p>
      </div>
      <div className="absolute flex flex-col font-['Nunito:Medium',_sans-serif] font-medium h-[35px] justify-center leading-[0] left-[17px] text-[#767676] text-[12px] top-[710.27px] translate-y-[-50%] w-[306px]">
        <p className="leading-[1.4]">Des quiz interactifs pour évaluer et approfondir vos compétences, adaptés aux parcours de formation suivis.</p>
      </div>
      <div className="absolute flex h-[140px] items-center justify-center left-[288px] top-[711.77px] w-[150px]">
        <div className="flex-none" style={{ transform: "rotate(180deg) scaleY(-1)" }}>
          <Frame2147239051 />
        </div>
      </div>
      <SlideToStart onCompleted={handleSlideCompleted} />
      {showForm ? <AuthForm onClose={handleCloseForm} onSuccess={handleAuthSuccess} /> : null}
      <Logo1 />
    </div>
  );
}
